import {inject} from "@angular/core";
import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import {RaceRouteService} from "@services";
import {RaceRoute} from "@model";

export const RaceRouteResolver: ResolveFn<Observable<RaceRoute|undefined> | (RaceRoute|undefined)> =
  (route: ActivatedRouteSnapshot,
   state: RouterStateSnapshot,
   raceRouteService: RaceRouteService = inject(RaceRouteService)): Observable<RaceRoute|undefined> | (RaceRoute|undefined) => {
    if (+route.queryParams['raceId']) {
      return raceRouteService.fetchRaceRoute(+route.queryParams['raceId']);
    } else {
      return undefined;
    }
  }
